import TableSelection from 'assets/js/editor/table/table-selection';
import TableEditor from '../../../table/table-editor';
import ElementCreator from './abstract/element';

class TableCreator extends ElementCreator {
  initialize () {
    super.initialize();
    this.mandatory = ['rowsCount', 'columnsCount'];
  }

  #createBorders (table, data) {
    const borders = this.canvas.addSvgElementFromJson({
      element: 'g',
      attr: {
        class: 'table-borders'
      }
    });

    table.appendChild(borders);

    const tableEditor = new TableEditor(table);

    for (let i = 0; i < data.rowsCount; i++) {
      const isLastRow = i === data.rowsCount - 1;

      // Create a new row
      const row = tableEditor.insertRow(i, data.cellHeight);

      // Add new cells to the newly created row
      for (let j = 0; j < data.columnsCount; j++) {
        const isLastColumn = j === data.columnsCount - 1;

        const cell = row.insertCell(data.x + j * data.cellWidth, data.y + i * data.cellHeight, data.cellWidth, data.cellHeight, j);

        const borderSettings = { ...INKIVE.Table.defaultBorderSettings };
        borderSettings.where = `${INKIVE.Table.borderFlagsLeft}${INKIVE.Table.borderFlagsTop}`;
        borderSettings.strokeWidth = borderSettings.strokeWidth * (this.canvas.contentW * 0.1) / 100;

        if (isLastColumn) borderSettings.where += INKIVE.Table.borderFlagsRight;
        if (isLastRow) borderSettings.where += INKIVE.Table.borderFlagsBottom;

        tableEditor.addBorder(cell.cellElement, borderSettings);
      }
    }
  }

  // Creates a table on canvas
  create (data) {
    // Table base group
    const element = this.canvas.addSvgElementFromJson({
      element: 'g',
      attr: {
        id: this.canvas.getNextId(),
        class: 'element table'
      }
    });

    // Table position and size
    const rect = this.canvas.addSvgElementFromJson({
      element: 'rect',
      attr: {
        id: this.canvas.getNextId(),
        x: data.x,
        y: data.y,
        width: data.width,
        height: data.height,
        fill: 'none'
      }
    });

    element.appendChild(rect);

    this.#createBorders(element, data);

    this.trigger('', element.getAttribute('id'));

    if (typeof data.selected === 'undefined' || data.selected) {
      this.canvas.selectOnly([element]);
    }

    INKIVE.Table.tableSelectionInstance = new TableSelection(element);
    INKIVE.Table.buildCornerGrip(element);

    return element.getAttribute('id');
  }
}

module.exports = TableCreator;
